import { ProductApiDto, SkuApiDto } from '@b2x/storefront-api-js-client/src';
import React from 'react';

import { Button } from './Button';
import { Col } from './Col';
import { AddToCartFieldsHelper } from './form/AddToCartForm';
import { Radio } from './form/fields/RadioCheck';
import { Select } from './form/fields/Select';
import { FormGroup } from './form/FormGroup';
import { Div } from './HTMLElement';
import { t } from './i18n/i18n';
import { Row } from './Row';
import { UsePriceResult } from './usePrice';
import { PropsWithCustomComponent, VariantsController } from './VariantsController';

export interface RecommendedCartProductTileExtraInfoProps {
  fieldsHelper: AddToCartFieldsHelper;
  onToggleShowMore(): void;
  priceHelper: UsePriceResult;
  product: ProductApiDto;
  showMore: boolean;
  sku?: SkuApiDto;
}

const RecommendedCartProductTileExtraInfo = ({
  fieldsHelper,
  onToggleShowMore,
  product,
  showMore,
}: RecommendedCartProductTileExtraInfoProps) => {
  return (
    <Div paddingTop={2}>
      <Row gap={3}>
        <Col size={{ md: '', xs: '' }}>
          <FormGroup {...fieldsHelper.productVariantsFieldSet.productVariants.formGroup} label={undefined}>
            {fieldsHelper.productVariantsFieldSet.productVariants.formFields.map((formField) => (
              <Radio key={formField.productVariant.id} {...formField.radio} inline />
            ))}
          </FormGroup>
          {fieldsHelper.skuAttributes.map(({ attribute, formGroup, radios }) => (
            <FormGroup
              {...formGroup}
              key={attribute.title}
              label={attribute.title + (attribute.value ?? t('product.selectSize'))}
            >
              {radios.map(({ radio }) => (
                <Radio key={radio.id} {...radio} inline />
              ))}
            </FormGroup>
          ))}
        </Col>
        <Col size={{ sm: 'auto', xs: 12 }}>
          <FormGroup {...fieldsHelper.quantity.formGroup} label={undefined} noMarginBottom>
            <Select
              {...fieldsHelper.quantity.select}
              aria-label={t('accessibility.select.quantity', { productName: product.name })}
              className="quantity-select text-center"
              includeEmptyOption={false}
              placeholder={undefined}
            />
          </FormGroup>
        </Col>
        <Col size={12}>
          <Div display={'flex'} gap={3} justifyContent={'end'} paddingTop={{ md: 3 }}>
            <Button size="small" type="submit" variant="link">
              {t('form.recommendedCartProduct.buttons.submit.label')}
            </Button>
            <Button onClick={onToggleShowMore} size="small" type="button" variant="link">
              {t('form.recommendedCartProduct.buttons.reset.label')}
            </Button>
          </Div>
        </Col>
      </Row>
    </Div>
  );
};

export type RecommendedCartProductTileExtraInfoVariants = '';

const RecommendedCartProductTileExtraInfoController = React.memo(
  (props: PropsWithCustomComponent<RecommendedCartProductTileExtraInfoProps>) => (
    <VariantsController<RecommendedCartProductTileExtraInfoProps, RecommendedCartProductTileExtraInfoVariants>
      {...props}
      variantsControllerConfig={{
        defaultComponent: RecommendedCartProductTileExtraInfo,
        name: 'RecommendedCartProductTileExtraInfo',
      }}
    />
  ),
);
RecommendedCartProductTileExtraInfoController.displayName = 'RecommendedCartProductTileExtraInfoController';

export { RecommendedCartProductTileExtraInfoController as RecommendedCartProductTileExtraInfo };
